export default "__VITE_ASSET__Bco6lSp6__"